import { render } from "./ViewLiquidationHistory.vue?vue&type=template&id=f3ec42bc"
import script from "./ViewLiquidationHistory.vue?vue&type=script&lang=js"
export * from "./ViewLiquidationHistory.vue?vue&type=script&lang=js"

import "./ViewLiquidationHistory.vue?vue&type=style&index=0&id=f3ec42bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__